import "./HorizontalLineComponent.scss";

interface HorizontalLineComponentProps {
    className?: string;
    marginBottom?: boolean;
    marginTop?: boolean;
}

const HorizontalLineComponent = (props: HorizontalLineComponentProps) => {
    const {className, marginBottom, marginTop} = props;
    return (
        <div
            className={`horizontal-line-wrapper ${className} + ${marginBottom ? "margin-bottom" : ''} + ${marginTop ? "margin-top" : ''}`}>

        </div>
    );

};

export default HorizontalLineComponent;